import React from "react";

const DC_Play = () => {
  return (
    <svg width="47" height="46" viewBox="0 0 47 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M23.4566 0C10.8579 0 0.644531 10.2133 0.644531 22.8121C0.644531 35.4108 10.8579 45.6242 23.4566 45.6242C36.0554 45.6242 46.2687 35.4108 46.2687 22.8121C46.2687 10.2133 36.0554 0 23.4566 0ZM18.8941 30.4108L31.3371 23.2268L18.8941 16.0429V30.4108Z" fill="white"/>
    </svg>
  );
};
export default DC_Play;